import type { BilingualLabel } from '../../components/Bilingual'

// R199 (b) — the kitchen screen's labels, one file so Rook's Arabic carry (c) is a one-file
// carry. Bilingual shows English alone for a null Arabic. UX form pass bench 4: the 22 labels
// that were null carry Rook's Arabic, byte-copied from his vault file (kitchen-ar-labels).

export type KitchenLabelKey =
  | 'title'
  | 'statusPENDING'
  | 'statusIN_PROGRESS'
  | 'statusBLOCKED'
  | 'actionStart'
  | 'actionBlock'
  | 'actionResume'
  | 'actionReady'
  | 'reasonMISSING_INGREDIENT'
  | 'reasonALLERGY_SAFETY'
  | 'reasonEQUIPMENT'
  | 'reasonOTHER'
  | 'blockTitle'
  | 'reasonLabel'
  | 'noteLabel'
  | 'submitBlock'
  | 'cancel'
  | 'loading'
  | 'empty'
  | 'loadError'
  | 'retry'
  | 'changed'
  | 'tvNeedsPrep'
  | 'tvInPrep'
  | 'tvReady'
  | 'tvStartTitle'
  | 'tvStartButton'
  | 'tvAudioBlocked'
  | 'tvUpdated'
  | 'tvStale'

export const KITCHEN_LABEL: Record<KitchenLabelKey, BilingualLabel & { ar: string | null }> = {
  title: { en: 'Kitchen', ar: 'المطبخ' },
  statusPENDING: { en: 'Pending', ar: 'بالانتظار' },
  statusIN_PROGRESS: { en: 'In prep', ar: 'قيد التحضير' },
  statusBLOCKED: { en: 'Blocked', ar: 'متوقّف' },
  actionStart: { en: 'Start', ar: 'ابدأ' },
  actionBlock: { en: 'Block', ar: 'أوقف' },
  actionResume: { en: 'Resume', ar: 'تابع' },
  actionReady: { en: 'Complete', ar: 'إنهاء' },
  reasonMISSING_INGREDIENT: { en: 'Missing ingredient', ar: 'مكوّن ناقص' },
  reasonALLERGY_SAFETY: { en: 'Allergy / safety', ar: 'حساسية / سلامة' },
  reasonEQUIPMENT: { en: 'Equipment', ar: 'عطل في المعدّات' },
  reasonOTHER: { en: 'Other', ar: 'سبب آخر' },
  blockTitle: { en: 'Block this task', ar: 'إيقاف هذه المهمة' },
  reasonLabel: { en: 'Reason', ar: 'السبب' },
  noteLabel: { en: 'Note', ar: 'ملاحظة' },
  submitBlock: { en: 'Block task', ar: 'إيقاف المهمة' },
  cancel: { en: 'Cancel', ar: 'إلغاء' },
  loading: { en: 'Loading\u2026', ar: 'جارٍ التحميل…' },
  empty: { en: 'No kitchen tasks.', ar: 'لا توجد مهام في المطبخ.' },
  loadError: { en: "Couldn't load the kitchen tasks.", ar: 'تعذّر تحميل مهام المطبخ.' },
  retry: { en: 'Try again', ar: 'حاول مجددًا' },
  changed: { en: 'This task changed; showing its current state.', ar: 'تغيّرت هذه المهمة؛ تُعرض حالتها الحالية.' },
  tvNeedsPrep: { en: 'Needs prep', ar: 'بانتظار التحضير' },
  tvInPrep: { en: 'In prep', ar: 'قيد التحضير' },
  tvReady: { en: 'Done', ar: 'تم' },
  tvStartTitle: { en: 'Kitchen board', ar: 'لوحة المطبخ' },
  tvStartButton: { en: 'Tap to start (turns the sound on)', ar: 'اضغط للبدء (يشغّل الصوت)' },
  tvAudioBlocked: { en: 'Sound is still blocked. Tap again.', ar: 'الصوت ما زال مقفلاً. اضغط مرة ثانية.' },
  tvUpdated: { en: 'Updated', ar: 'آخر تحديث' },
  tvStale: { en: 'Not updating: check the connection', ar: 'لا يتم التحديث: تحقّق من الاتصال' },
}
